<cdk-virtual-scroll-viewport #scroller itemSize="46" class="content">
    <div class="list-group">
        <ng-container *cdkVirtualFor="let item of items">
            <a (click)="selectItem(item)" class="list-group-item list-group-item-action" [class.active]="selectedItem === item">{{ item[itemDisplayKey] }}</a>
        </ng-container>
    </div>
</cdk-virtual-scroll-viewport>
